import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import User from '../User/User';
const DashboardHome = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        setIsLoading(true);
        fetch('https://gentle-tor-99938.herokuapp.com/users')
            .then(res => res.json())
            .then((users) => {
                setUsers(users)
            })
            .finally(() => {
                setIsLoading(false);
            });

        setIsLoading(true);

        fetch('https://gentle-tor-99938.herokuapp.com/reviews')
            .then(res => res.json())
            .then((reviews) => setReviews(reviews))
            .finally(() => {
                setIsLoading(false);
            });
    }, [])


    return (
        <div>

            {
                isLoading
                    ?
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
                    :
                    <div>
                        <div className="row g-3 my-2 text-white">
                            <div className="col-lg-6 col-xl-3">
                                <div className="p-4 shadow-sm d-flex justify-content-around align-items-center rounded" style={{ backgroundColor: '#3984ff' }}>
                                    <div className="col-8">
                                        <h3 className="fw-bold fs-2 m-0">3</h3>
                                        <p className="m-0">Banners</p>
                                    </div>
                                    <span className="col-4 text-start">
                                        <i className="fa-solid fa-image fs-2 primary-text border rounded-full secondary-bg p-3 m-0"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="col-lg-6 col-xl-3">
                                <div className="p-4 shadow-sm d-flex justify-content-around align-items-center rounded" style={{ backgroundColor: '#fa5649' }}>
                                    <div className="col-8">
                                        <h3 className="fw-bold fs-2 m-0">6</h3>
                                        <p className="m-0">Special Items</p>
                                    </div>
                                    <span className="col-4 text-start">
                                        <i className="fas fa-box fs-2 primary-text border rounded-full secondary-bg p-3 m-0"></i>
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-3">
                                <div className="p-4  shadow-sm d-flex justify-content-around align-items-center rounded" style={{ backgroundColor: '#ffa113' }}>
                                    <div className="col-8">
                                        <h3 className="fw-bold fs-2 m-0">{users?.length}</h3>
                                        <p className="m-0">Users</p>
                                    </div>
                                    <span className="col-4 text-start">
                                        <i
                                            className="fas fa-users fs-2 primary-text border rounded-full secondary-bg p-3 m-0"></i>
                                    </span>

                                </div>
                            </div>

                            <div className="col-lg-6 col-xl-3">
                                <div className="p-4  shadow-sm d-flex justify-content-around align-items-center rounded" style={{ backgroundColor: '#5a00dd' }}>
                                    <div className="col-8">
                                        <h3 className="fw-bold fs-2 m-0">{reviews?.length}</h3>
                                        <p className="m-0">Reviews</p>
                                    </div>
                                    <span className="col-4 text-start">
                                        <i className="fas fa-pen fs-2 primary-text border rounded-full secondary-bg p-3 m-0"></i>
                                    </span>

                                </div>
                            </div>
                        </div>

                        <div className="mt-5">
                            <Table bordered hover >
                                <thead>
                                    <tr>
                                        <th className="d-none d-md-table-cell">#</th>
                                        <th className="d-none d-md-table-cell">Name</th>
                                        <th>Email</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        users.map((userData, index) => <User
                                            key={userData._id}
                                            index={index}
                                            userData={userData}
                                        />)
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </div>
            }

        </div >
    );
};

export default DashboardHome;